import { useEffect } from "react"

const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button",
  "input",
  "select",
  "textarea",
  "area[href]",
  "details",
  "summary",
  "iframe",
  "video[controls]",
  "audio[controls]",
  "[contenteditable]",
  '[role="button"]',
  '[role="link"]',
  '[tabindex]:not([tabindex="-1"])',
].join(", ")

const useBackgroundInert = isOpen => {
  useEffect(() => {
    if (!isOpen) return

    const root = document.getElementById("root")
    if (!root) return

    const elements = Array.from(root.querySelectorAll(FOCUSABLE_SELECTOR))
    const originalTabIndices = new Map()

    elements.forEach(el => {
      originalTabIndices.set(el, el.getAttribute("tabindex"))
      el.setAttribute("tabindex", "-1")
    })

    return () => {
      elements.forEach(el => {
        const original = originalTabIndices.get(el)
        if (original === null) {
          el.removeAttribute("tabindex")
        } else {
          el.setAttribute("tabindex", original)
        }
      })
    }
  }, [isOpen])
}

export default useBackgroundInert
